import { Link } from "react-router-dom";

const NoMatchPage: React.FC<{}> = () => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  </div>
);

export default NoMatchPage;
